import TimeSeriesEditor from './timeSeries/TimeSeries.json';
import CategoricalBarEditor from './categoricalBar/CategoricalBar.json';
import StatusCardGroupEditor from './statusCardGroup/StatusCardGroup.json';
import HeatGridEditor from './heatGrid/HeatGrid.json';
import RatioBarEditor from './ratioBar/RatioBar.json';

// TODO: programmatically export EditableComponent.editorTemplate for all visualization types
export default [TimeSeriesEditor, CategoricalBarEditor, StatusCardGroupEditor, HeatGridEditor, RatioBarEditor];
